export default __webpack_public_path__ + "static/media/painting1.40fe31dd.jpg";